// Where the captions sit on a captioned video, picked per piece in the Add
// Post wizard. Mirrors the api's optional `captionPosition`: omitting it
// renders at the bottom, exactly as captioned videos did before the choice.
export type CaptionPosition = "top" | "middle" | "bottom";
export const CAPTION_POSITIONS: readonly CaptionPosition[] = ["top", "middle", "bottom"];
export const DEFAULT_CAPTION_POSITION: CaptionPosition = "bottom";

// The create-body field: a missing captionPosition means bottom on the api, so
// only a Top/Middle pick is sent and a default body stays as it always was.
export const captionPositionField = (
    p: CaptionPosition
): { captionPosition?: CaptionPosition } => (p === "bottom" ? {} : { captionPosition: p });
